export class Certificate {
  constructor(data) {
    this.id = data.id;
    this.name = data.name;
    this.validityPeriod = data.validityPeriod;
    this.createdDate = data.createdDate;
    this.editedDate = data.editedDate;
    this.isActive = data.isActive;
  }
}

export class TrainingCertificate {
  constructor(data) {
    this.id = data.id;
    this.registrationId = data.registrationId;
    this.code = data.code;
    this.certificateId = data.certificateId;
    this.createdDate = data.createdDate;

    /** @type {Certificate|null} */
    this.certificate = data.certificate;
  }
}
